import React from 'react';

export const StickyFooterContainer: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className='fixed inset-x-0 bottom-0 z-sticky-footer'>{children}</div>
);
